import { createSlice } from "@reduxjs/toolkit";
import { socialLoginAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const socialLoginSlice = createSlice({
  name: "socialLogin",
  initialState: data,
  reducers: {
    socialLoginSlice(state) {
      state.isLoading = false;
    },
    socialLoginSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    socialLoginSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload;
    },
    socialLoginSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const socialLoginUserHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(socialLoginUserAction.socialLoginSlice());
    const response: any = await socialLoginAPI(data);
   
    
    typeof localStorage !=="undefined"&&localStorage.setItem('token', response?.results?.token);
    typeof localStorage !== "undefined" && localStorage.setItem('username', response?.results?.username);
    typeof localStorage !=="undefined"&&localStorage.setItem('user_type', response?.results?.type);
    typeof localStorage !== "undefined" && localStorage.setItem('profile_picture', response?.results?.profile_picture);
     typeof localStorage !=="undefined"&&localStorage.setItem('userId', response?.results?.user_id);
    typeof localStorage !=="undefined"&&localStorage.setItem('role', response?.results?.type);
    dispatch(socialLoginUserAction.socialLoginSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    showErrorToast(e?.response?.data?.error_message)
    dispatch(socialLoginUserAction.socialLoginSliceFailure(e?.response?.data));
  }
};
export default socialLoginSlice.reducer;
export const socialLoginUserAction = socialLoginSlice.actions;
